import { useState } from "react";
import { IInitialServerProducts } from "./actions/getInitialProducts";
import { IMinUser } from "@/Models/User/IUser";



export function useValues (initialValue: IInitialServerProducts, initialUser?: IMinUser) {
  const [state, setState] = useState(initialValue);
  const [userinfo, setUserinfo] = useState(initialUser);
  

  return {
    state: {
      data: state.data,
      totalPages: state.totalPages,
      totalElements: state.totalElements,
      userinfo: userinfo,
    },
    actions: {}
  }
}

export type ProductsServerStateContextType = ReturnType<typeof useValues>;
